// extracted by mini-css-extract-plugin
module.exports = {"badgeContainer":"HomeBadgesSection_badgeContainer__Lj0o1","badgeLogo":"HomeBadgesSection_badgeLogo__1TXgD"};